let storage;
if ('true' === process.env.TARGET_ELECTRON) {
    // tslint:disable-next-line
    const FSStorage = require('./FSStorage').default;
    storage = new FSStorage();
}
else {
    // tslint:disable-next-line
    const LocalStorage = require('./LocalStorage').default;
    storage = new LocalStorage();
}
export default storage;
